import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

interface IGetMasterCompanyData {
  id: number,
  company_code: string,
  company_code_1: string,
  company_code_2: string,
  company_code_3: string,
  company_friend: string,
  description: string,
  create_at: string,
  create_by: string,
  update_by: string,
  update_at: string,
}

export interface IGetMasterCompanyResponse {
  list_mtcompany: IGetMasterCompanyData[]
}

interface GetMasterCompanyParamsI {
  company_code?: string,
}

export const url = "/v1/mtcompany";

export const getMasterCompany = async (
  payload?: GetMasterCompanyParamsI,
): Promise<IGetMasterCompanyResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getMasterCompanyRelationByCompanyId = async (
  companyId: string,
): Promise<IGetMasterCompanyResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${companyId}`,
    method: "GET",
  });

  return data;
};
